import styled, { css } from 'styled-components';

interface ContainerProps {
  isFilled: boolean;
  isFocuses: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  border-radius: 10px;
  border: 1px solid #454545;
  background-color: #3a3a3a;
  padding: 5px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  height: 44px;

  + div {
    margin-top: 8px;
  }

  div {
    width: 100%;
    position: relative;
  }

  input {
    width: 100%;
    flex: 1;
    background: transparent;
    border: 0;
    color: #fff;
    transition-duration: 0.2s;
    padding: 0 5px;
    outline: 0;

    ::placeholder {
      color: #bbb;
    }
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #ff333d !important;
    `}

  ${(props) => props.isFilled && css``}

  ${(props) =>
    props.isFocuses &&
    css`
      color: #606060;
      border-color: #606060 !important;
    `}
`;
